<template>
  <div class="content">

    <el-row class="bgW">
      <el-col :span="22">
        <!--检索条件-->
        <el-form class="search" :inline="true" size="mini" :model="search">
          <el-form-item label="客户姓名">
            <el-input
              v-model="search.customer_name"
              placeholder="请输入客户姓名"
              class="w120"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="卡项名称">
            <el-input
              v-model="search.service_name"
              placeholder="请输入卡项名称"
              class="w120"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="手机号">
            <el-input
              v-model="search.telephone"
              placeholder="请输入手机号"
              class="w120"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="护理师">
            <el-input
              v-model="search.nurse_name"
              placeholder="请输入"
              class="w120"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="星级">
            <el-select v-model="search.score" clearable class="w120">
              <el-option
                v-for="item in options.score"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="评价渠道">
            <el-select v-model="search.source_id" clearable class="w120">
              <el-option
                v-for="item in options.source_id"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          
          <el-form-item label="评价来源">
            <el-select v-model="search.channel" clearable class="w120">
              <el-option
                v-for="item in options.channel"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="评价状态">
            <el-select v-model="search.status" clearable class="w120">
              <el-option
                v-for="item in options.status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="市场" v-if="!userInfo.shop_id">
            <el-select
              v-model="search.market_id"
              clearable
              remote
              filterable
              :remote-method="getMarket"
              placeholder="请输入"
              class="w120"
            >
              <el-option
                v-for="item in options.market_id"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="门店/门诊" v-if="!userInfo.shop_id">
            <el-select
              v-model="search.shop_id"
              clearable
              remote
              filterable
              :remote-method="remoteMethod"
              placeholder="请输入"
              class="w120"
            >
              <el-option
                v-for="item in options.shop_id"
                :key="item.shopId"
                :label="item.shopName"
                :value="item.shopId"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="评价时间">
            <el-date-picker
              v-model="search.start"
              type="date"
              class="w130"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
            <el-date-picker
              v-model="search.end"
              type="date"
              class="w130"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2" style="text-align: right;">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>

      </el-col>
    </el-row>

    <div class="accountCon">
      <div class="btnBox">
        <el-button
          type="primary"
          class="mb10"
          size="mini"
          v-if="!userInfo.shop_id"
          @click="exportData('export')"
        >导出数据</el-button>

        <el-button
          type="primary"
          class="mb10"
          size="mini"
          v-if="!userInfo.shop_id"
          @click="openScoreSettingDialog"
        >修改评分比例</el-button>
        <el-button 
          type="primary" 
          class="mb10"
          icon="el-icon-plus" 
          size="mini" 
          @click="openAddEvaluationDialog"
        >
          新增评价
        </el-button>
      </div>

      <!-- 评分比例设置弹窗 -->
      <el-dialog
        title="修改评分比例设置"
        :visible.sync="scoreSettingDialogVisible"
        width="25%"
        :before-close="handleDialogClose"
      >
        <el-form ref="scoreForm" :model="scoreForm" :rules="scoreRules" label-width="180px">
          <el-form-item prop="scoring">
            <template slot="label">
              差评与好评计算规则
              <el-tooltip content="单题评分不足100分时，根据输入框的数值进行计算" placement="top">
                <i class="el-icon-question" style="color:#909399; margin-left:4px; cursor:pointer;"></i>
              </el-tooltip>
            </template>

            <el-input
              v-model="scoreForm.scoring"
              type="number"
              min="1"
              placeholder="请输入X个好评可以抵1个差评"
            ></el-input>
          </el-form-item>
          <el-form-item label="评价赠送积分" prop="points">
            <el-input
              v-model="scoreForm.points"
              type="number"
              min="0"
              placeholder="请输入评价赠送的积分"
            ></el-input>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="handleDialogClose">取消</el-button>
          <el-button type="primary" @click="saveScoreSetting" :loading="loading">确定</el-button>
        </div>
      </el-dialog>

      <!-- 回复弹窗 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="50%"
        :close-on-click-modal="false"
        class="reply-dialog"
      >
        <div class="feedback-detail">
          <div class="info-card customer-info">
            <h3 class="card-title">客户评价信息</h3>
            <el-row>
              <el-col :span="6">
                <div class="feedback-item">
                  <span class="label">客户姓名：</span>
                  <span>{{ currentFeedback.customer_name || '未知' }}</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="feedback-item">
                  <span class="label">手机号：</span>
                  <span>{{ currentFeedback.telephone || '未知' }}</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="feedback-item">
                  <span class="label">市场：</span>
                  <span>{{ currentFeedback.market_name || '-' }}</span>
                </div>
              </el-col>

              <el-col :span="6">
                <div class="feedback-item">
                  <span class="label">门店/门诊：</span>
                  <span>{{ currentFeedback.shop_name || '-' }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <div class="feedback-item">
                  <span class="label">卡项名称：</span>
                  <span>{{ currentFeedback.service_name || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="feedback-item">
                  <span class="label">服务单号：</span>
                  <span>{{ currentFeedback.service_id || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="feedback-item">
                  <span class="label">核销员工1：</span>
                  <span>{{ currentFeedback.nurse_one_name || '-' }}</span>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="feedback-item">
                  <span class="label">核销员工2：</span>
                  <span>{{ currentFeedback.nurse_two_name || '-' }}</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <div class="feedback-item">
                  <span class="label">评价分数：</span>
                  <span>{{ currentFeedback.score || 0 }}/{{ currentFeedback.full_score || 500 }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="feedback-item">
                  <span class="label">评价时间：</span>
                  <span>{{ currentFeedback.create_time || '-' }}</span>
                </div>
              </el-col>
            </el-row>

            <div class="feedback-item evaluation-content-wrapper">
              <span class="label">评价内容：</span>
              <div class="evaluation-content">
                <span v-for="(item, index) in currentFeedback.content" :key="index" class="evaluation-item">
                  <span>{{ index + 1 }}、</span>
                  <span class="question">{{ item.question }}：</span>
                  <span class="answer">{{ formatAnswer([item], item.question) }}</span>；
                </span>
              </div>
            </div>
          </div>

          <!-- 客服添加：显示历史回复列表 -->
          <div class="info-card reply-section resolved-content" v-if="currentFeedback.channel == '客服添加' && currentFeedback.reply && currentFeedback.reply.length > 0">
            <h3 class="card-title">历史回复记录</h3>
            <div class="reply-list">
              <div v-for="(item, idx) in currentFeedback.reply" :key="idx" class="reply-item">
                <span>{{ idx + 1 }}、{{ item.time || '未知时间' }}</span>
                <p>{{ item.content || '无内容' }}</p>
              </div>
            </div>
          </div>

          <!-- 用户评价：显示历史回复 -->
          <div class="info-card reply-section resolved-content" v-else-if="currentFeedback.channel == '用户评价' && showReplyList.length > 0">
            <h3 class="card-title">历史回复记录</h3>
            <el-steps direction="vertical" :active="showReplyList.length">
              <el-step
                v-for="(item, index) in showReplyList"
                :key="index"
                :title="item.time || '未知时间'"
                :description="item.content || '-'"
              />
            </el-steps>
          </div>

          <!-- 新增回复输入框 -->
          <div class="info-card reply-section">
            <h3 class="card-title">新增回复</h3>
            <el-form
              :model="replyForm"
              ref="replyForm"
              label-width="80px"
            >
              <el-form-item
                label="回复内容"
                prop="reply"
                class="w-full"
                :rules="[{ required: true, message: '请输入回复内容', trigger: 'blur' }]"
              >
                <el-input
                  v-model="replyForm.reply"
                  type="textarea"
                  rows="4"
                  placeholder="请输入新的回复内容..."
                  class="reply-textarea"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" class="cancel-btn">关闭</el-button>
          <el-button
            type="primary"
            @click="submitReply"
            class="submit-btn"
            :loading="loading"
          >
            提交回复
          </el-button>
        </div>
      </el-dialog>

      <!-- ====================== 新增/编辑服务评价弹窗 ====================== -->
      <el-dialog
        :title="evaluationDialogTitle"
        :visible.sync="addEvaluationVisible"
        width="800px"
        append-to-body
        @close="handleEvaluationDialogClose"
      >
        <div class="add-evaluate-wrap">
          <el-form
            ref="addEvaluationForm"
            :model="addEvaluationForm"
            :rules="addEvaluationRules"
            label-width="110px"
            size="small"
          >
            <div class="form-section">
              <span class="section-title">基础信息</span>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="客户姓名" prop="customerInfo">
                    <el-select
                      v-model="addEvaluationForm.customerInfo"
                      filterable
                      value-key="id"
                      remote
                      placeholder="输入姓名/手机号搜索"
                      :remote-method="loadUserList"
                      style="width: 100%;"
                      @change="getPersonList1"
                    >
                      <el-option
                        v-for="item in customerList"
                        :key="item.id"
                        :label="item.customer_name"
                        :value="item"
                      >
                        <span style="float: left">{{ item.customer_name }} ({{ item.shop_name }})</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.telephone }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="客户手机号" prop="telephone">
                    <el-input v-model="addEvaluationForm.customerInfo.telephone" readonly placeholder="自动填充" />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="归属门店" prop="shop_id">
                    <el-input v-model="addEvaluationForm.customerInfo.shop_name" readonly placeholder="自动填充" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                   <el-form-item label="评价渠道" prop="source_id">
                    <el-select v-model="addEvaluationForm.source_id" placeholder="请选择渠道" :options="options.source_id">
                      <el-option v-for="item in options.source_id" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                  </el-form-item> 
                </el-col>
              </el-row>
               <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="评价护理师1" prop="nurse_one_id">
                    <el-select
                      v-model="addEvaluationForm.nurse_one_id"
                      placeholder="请选择护理师1"
                      style="width: 100%;"
                      filterable
                    >
                      <el-option
                        v-for="item in personList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                        <span style="float: left">{{ item.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.position_name }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="评价护理师2" prop="nurse_two_id">
                    <el-select
                      v-model="addEvaluationForm.nurse_two_id"
                      placeholder="请选择护理师2"
                      style="width: 100%;"
                      filterable
                    >
                      <el-option
                        v-for="item in personList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                        <span style="float: left">{{ item.name }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.position_name }}</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="评价状态" prop="status">
                    <el-radio-group v-model="addEvaluationForm.status">
                      <el-radio :label="0">处理中</el-radio>
                      <el-radio :label="1">已完成</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>

            <div class="form-section">
              <span class="section-title">评价内容</span>
              <div class="questions-group">
                <div
                  class="question-item"
                  v-for="(item, idx) in addEvaluationForm.questions"
                  :key="idx"
                >
                  <span>{{ item.title }}</span>
                  <div>
                    <el-rate
                      v-model="item.answer"
                      :max="item.max_score"
                      v-if="item.question_type == 5"
                      show-score
                      text-color="#ff6600"
                      score-template="{value}星"
                    />
                    <el-input
                      v-model="item.answer"
                      type="textarea"
                      :rows="3"
                      class="w600"
                      v-if="item.question_type == 6"
                      placeholder="请输入内容"
                    />
                  </div>
                </div>
              </div>
            </div>
          </el-form>
        </div>

        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click="addEvaluationVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitAddEvaluation" :loading="addLoading">提 交</el-button>
        </div>
      </el-dialog>

      <!--列表-->
      <el-row>
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
            @selection-change="handleSelectionChange"
          >
            <ElTableColumn label="序号" type="index" width="55" fixed="left" />
            <ElTableColumn label="姓名" prop="customer_name" width="90" fixed="left" />
            <ElTableColumn label="手机" width="100" prop="telephone" fixed="left" />
            <ElTableColumn label="评价时间" width="130" prop="create_time" />
            <ElTableColumn label="评价来源" width="80" prop="channel" />
            <ElTableColumn label="评价状态" width="70" prop="status" >
              <template slot-scope="scope">
                {{ scope.row.status == 0 ? '处理中' : '已完成' }}
              </template> 
            </ElTableColumn>
            <ElTableColumn label="评价渠道" width="80">
              <template slot-scope="scope">
                {{ scope.row.source_id == 1 ? '400投诉' : scope.row.source_id == 2 ? '小程序' : scope.row.source_id == 3 ? '线上舆情' : scope.row.source_id == 4 ? '团购' : scope.row.source_id == 5 ? '回访' : '-' }}
              </template> 
            </ElTableColumn>
            <ElTableColumn label="服务单号" prop="service_id" width="80" />
            <ElTableColumn label="卡项名称" prop="service_name" width="150" />
            <ElTableColumn label="门店/门诊" prop="shop_name" width="90" />
            <ElTableColumn label="市场" prop="market_name" width="100" />
            <ElTableColumn label="核销员工1" prop="nurse_one_name" width="90" />
            <ElTableColumn label="核销员工2" prop="nurse_two_name" width="80" />
            <ElTableColumn label="评价分数" width="90">
              <template slot-scope="scope">
                <div>
                  <span>{{ scope.row.score }}/{{ scope.row.full_score }}</span>
                  <div class="score-stars">
                    <i
                      class="el-icon-star"
                      v-for="n in 5"
                      :key="n"
                      :class="{ 'star-active': n <= (scope.row.score / scope.row.full_score * 5) }"
                    ></i>
                  </div>
                </div>
              </template>
            </ElTableColumn>
            <ElTableColumn label="是否展示" prop="is_show" width="80">
              <template slot-scope="{ row }">
                <el-switch
                  v-model="row.is_show"
                  @change="(value) => handleSwitchChange(row, value, 'is_show')"
                  active-color="#33bea7"
                  :active-value="1"
                  :inactive-value="2"
                  :disabled="row.loading ||  ![ 443, 853, 1, 1901, 1917,1916,1927,1737,1752 ].includes(userInfo.id)"
                >
                </el-switch>
              </template>
            </ElTableColumn>
            <ElTableColumn label="是否置顶评价" prop="is_top" width="80">
              <template slot-scope="{ row }">
                <el-switch
                  v-model="row.is_top"
                  @change="(value) => handleSwitchChange(row, value, 'is_top')"
                  active-color="#33bea7"
                  :active-value="1"
                  :inactive-value="2"
                  :disabled="row.loading ||  ![ 443, 853, 1, 1901, 1917,1916,1927,1737,1752 ].includes(userInfo.id)"
                >
                </el-switch>
              </template>
            </ElTableColumn>

            <template v-for="(question, index) in questionTitles">
              <ElTableColumn
                :label="question"
                :width="index === questionTitles.length - 1 ? '300' : '80'"
                :key="index"
              >
                <template slot-scope="scope">
                  {{ formatAnswer(scope.row.content, question) }}
                </template>
              </ElTableColumn>
            </template>

            <ElTableColumn label="回复内容" prop="reply" width="180" >
              <template slot-scope="scope"> 
                <el-popover
                  placement="bottom"
                  title="回复详情"
                  width="400"
                  trigger="click"
                  >
                  <el-steps direction="vertical" v-if="Array.isArray(scope.row.reply)"  :active="scope.row.reply.length ">
                    <el-step
                      v-for="(item, index) in scope.row.reply"
                      :key="index"
                      :title="item.time || '未知时间'"
                      :description="item.content || '-'">
                    </el-step>
                  </el-steps>
                  <div v-else>
                    {{ scope.row.reply || '-' }}
                  </div>
                  
                  <div slot="reference" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <div v-if="typeof scope.row.reply === 'string'">
                      {{ scope.row.reply || '-' }}
                    </div>
                    <div v-else>
                      <div v-for="(item, index) in scope.row.reply" :key="index">
                        {{ item.time }} {{ item.content }}
                      </div>
                    </div>
                  </div>
                </el-popover>
              </template>
            </ElTableColumn>

            <ElTableColumn label="操作" fixed="right" width="130">
              <template slot-scope="{ row }">
                <span class="theme" @click="goEdit(row)" v-if="row.channel == '客服添加'">编辑</span>
                <span class="theme" @click="goHuifu(row)" v-if="row.channel == '客服添加' && row.status == 0">去回复</span>
                <span class="theme" @click="goHuifu(row)" v-if="row.channel == '用户评价'">去回复</span>
              </template>
            </ElTableColumn>
          </el-table>

          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import pagination from "@/components/Pagination";
import { clientExport } from "@/api/client";
import { getShopList,getPersonList, getMarketLsit } from "@/api/shop";
import {
  getRatingList,
  getEvaluationQuestions,
  getSystenList,
  updateRatingShow,
  updateSystem,
  getUserList,
  adminAddRating
} from "@/api/sys";

class Search {
  status = "";
  channel = "";
  source_id = "";
  customer_name = "";
  service_name = "";
  telephone = "";
  score = "";
  market_id = "";
  shop_id = "";
  start = this.formatDate(new Date(Date.now() - 10 * 24 * 60 * 60 * 1000));
  end = this.formatDate(new Date());
  nurse_name = "";

  formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
class Page {
  total = 0;
  page = 1;
  limit = 10;
}

class Options {
  shop_id = [];
  status = [
    { label: '处理中', value: 0 },
    { label: '已完成', value: 1 }
  ];
  score = [
    { label: '总分等于500分', value: 1 },
    { label: '总分低于500分', value: 2 },
  ];
  market_id = [];
  statusList = [
    { label: '已回复', value: 1 },
    { label: '处理中', value: 2 }
  ];
  source_id = [
    { label: '400投诉', value: 1 },
    { label: '小程序', value: 2 },
    { label: '线上舆情', value: 3 },
    { label: '团购', value: 4 },
    { label: '回访', value: 5 }
  ];
  channel = [
    { label: '用户评价', value: 0 },
    { label: '客服添加', value: 1 },
  ];
}

class ScoreForm {
  scoring = '';
  points = '';
}

export default {
  name: "EvaluationSearch",
  components: { pagination },
  data() {
    return {
      personList: [],
      search: new Search(),
      options: new Options(),
      questionTitles: [],
      page: new Page(),
      list: [],
      idList: "",
      loading: false,

      dialogVisible: false,
      dialogTitle: "评价详情与回复",
      currentFeedback: {},
      showReplyList: [],
      isProcessing: false,
      replyForm: { reply: '' },
      replyImageList: [],
      dialogVisibleImg: false,
      dialogImageUrl: '',
      uploadUrl: '/api/upload/image',

      scoreSettingDialogVisible: false,
      scoreForm: new ScoreForm(),
      scoreRules: {
        scoring: [{ required: true, message: '请输入差评与好评比例', trigger: 'blur' }],
        points: [{ required: true, message: '请输入评价赠送积分', trigger: 'blur' }]
      },

      addEvaluationVisible: false,
      addLoading: false,
      selectedCustomer: null,
      customerList: [],
      isEditMode: false,
      addEvaluationForm: {
        id: null,
        customerInfo: {},
        status: 0,
        source_id: "",
        questions: []
      },
      addEvaluationRules: {
        customerInfo: [{ required: true, message: "请选择客户", trigger: "change" }],
        source_id: [{ required: true, message: "请选择评价渠道", trigger: "change" }],
        nurse_one_id: [{ required: true, message: "请选择护理师1", trigger: "change" }]
      }
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    evaluationDialogTitle() {
      return this.isEditMode ? "编辑服务评价" : "新增服务评价";
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getPersonList1() {
      // 正确获取选中客户的门店ID
      const shopId = this.addEvaluationForm.customerInfo?.shop_id;
      console.log(shopId,"shopId")
      if (!shopId) {
        this.personList = [];
        return;
      }
      const res = await getPersonList({ shop_id: shopId });
      this.personList = res.data || [];
    },
    async openAddEvaluationDialog() {
      this.isEditMode = false;
      this.addEvaluationVisible = true;
      this.selectedCustomer = null;
      this.customerList = [];
      this.addEvaluationForm = {
        id: null,
        status: 0,
        customerInfo: {},
        nurse_one_id: "", // 评价人1
        nurse_two_id: "", // 评价人2
        source_id: "",
        questions: []
      };
      const res = await getEvaluationQuestions();
      this.addEvaluationForm.questions = res.map(item => {
        const defaultAnswer = item.question_type === 5 ? 1 : '';
        return {
          ...item,
          answer: defaultAnswer
        };
      });
    },

    async goEdit(row) {
     await this.loadUserList(row.telephone);
      try {
        this.isEditMode = true;
        this.addEvaluationVisible = true;
        
        const customerInfo = {
          id: row.customer_id,
          customer_name: row.customer_name,
          shop_id: row.shop_id,
          telephone: row.telephone,
          shop_name: row.shop_name
        };
        const questionsRes = await getEvaluationQuestions();
        
        const questions = questionsRes.map(item => {
          let answer = '';
          if (row.content && Array.isArray(row.content)) {
            const foundItem = row.content.find(
              content => content.question === item.title || content.question_id === item.id
            );
            if (foundItem) {
              answer = foundItem.start || foundItem.answer ;
            }
          }
          
          if (answer === undefined || answer === '') {
            answer = item.question_type === 5 ? 1 : '';
          }
          
          return {
            ...item,
            answer: answer
          };
        });
        
        this.addEvaluationForm = {
          id: row.id,
          status: row.status || 0,
          customerInfo: customerInfo,
          nurse_one_id: row.nurse_one_id || "", // 评价人1
          nurse_two_id: row.nurse_two_id || "", // 评价人2
          source_id: row.source_id || "",
          questions: questions
        };
        console.log(111,customerInfo,"1111")
        this.getPersonList1();
      } catch (err) {
        console.error("打开编辑弹窗失败:", err);
        this.$message.error("加载评价数据失败");
      }
    },

    handleEvaluationDialogClose() {
      this.$refs.addEvaluationForm?.resetFields();
      this.addEvaluationForm = {
        id: null,
        status: 0,
        customerInfo: {},
        nurse_one_id: "", // 评价人1
        nurse_two_id: "", // 评价人2
        source_id: "",
        questions: []
      };
      this.isEditMode = false;
    },

    async loadUserList(keyword) {
      if (!keyword) {
        this.customerList = [];
        return;
      }
      const res = await getUserList({ keyword });
      this.customerList = res || [];
    },

    submitAddEvaluation() {
      this.$refs.addEvaluationForm.validate(async valid => {
        if (!valid) return;
        
        const hasAnswer = this.addEvaluationForm.questions.some(
          item => item.answer !== undefined && item.answer !== null && item.answer !== ''
        );
        if (!hasAnswer) {
          this.$message.warning("请至少填写一项评价内容");
          return;
        }
        
        this.addLoading = true;

        const params = {
          status: this.addEvaluationForm.status,
          id: this.addEvaluationForm.id || undefined, 
          customer_id: this.addEvaluationForm.customerInfo.id,
          nurse_one_id: this.addEvaluationForm.nurse_one_id, // 评价人1
          nurse_two_id: this.addEvaluationForm.nurse_two_id, // 评价人2
          source_id: this.addEvaluationForm.source_id,
          content: this.addEvaluationForm.questions.map(item => ({
            question_id: item.id,
            answer: item.answer
          })),
          operator: this.userInfo.id
        };

        if (!this.addEvaluationForm.id) {
          delete params.id;
        }

        try {
          const res = await adminAddRating(params);
          if (res.code === 200) {
            this.$message.success(this.isEditMode ? "编辑评价成功" : "新增评价成功");
            this.addEvaluationVisible = false;
            this.getList();
          } else {
            this.$message.error(res.msg || (this.isEditMode ? "编辑失败" : "新增失败"));
          }
        } catch (err) {
          console.error(err);
        } finally {
          this.addLoading = false;
        }
      });
    },

    goHuifu(row) {
      this.dialogTitle = "评价回复";
      this.replyForm.reply = "";
      this.dialogVisible = true;
      this.currentFeedback = row;
      this.isProcessing = true;

      if (row.channel === "用户评价") {
        this.showReplyList = Array.isArray(row.reply) ? row.reply : [];
      }
    },

    handleSwitchChange(row, value, field) {
      row.loading = true;
      let params = {
        id: row.id,
        [field]: value,
        operator: this.userInfo.id
      };

      updateRatingShow(params)
        .then(res => {
          if (res.code === 200) {
            this.$message.success('状态更新成功');
            row[field] = value;
            this.getList();
          } else {
            this.$message.error(res.msg || '状态更新失败');
          }
        })
        .catch(() => {
          this.$message.error('网络错误');
        })
        .finally(() => {
          row.loading = false;
        });
    },

    getList(option) {
      if (option === "search") {
        this.page.page = 1;
      }
      const params = {
        ...this.search,
        page: this.page.page,
        page_size: this.page.limit,
        is_export: 0
      };
      getRatingList(params).then(res => {
        this.list = res.data;
        this.page.total = res.total;
        if (this.list.length > 0 && this.list[0].content) {
          this.questionTitles = this.list[0].content.map(item => item.question);
        }
      });
    },

    getMarket(e) {
      getMarketLsit({ page: 1, limit: 100000, marketName: e }).then(res => {
        this.options.market_id = res;
      });
    },

    exportData() {
      const params = { ...this.search, is_export: 1 };
      getRatingList(params).then(res => {
        window.open(res.url);
      });
    },

    remoteMethod(e) {
      getShopList({ page: 1, limit: 100000, shopName: e }).then(res => {
        this.options.shop_id = res.list;
      });
    },

    tapBtn(routerName, id) {
      const query = { id, activeName: "first" };
      let route = this.$router.resolve({ name: routerName, query });
      window.open(route.href, '_blank');
    },

    // 提交回复：客服添加走新增接口，用户评价走原接口
    async submitReply() {
      this.$refs.replyForm.validate(async valid => {
        if (!valid) return;
        this.loading = true;

        try {
          if (this.currentFeedback.channel === "客服添加") {
            // 客服添加：使用新增服务评价接口，字段 reply
            const params = {
              id: this.currentFeedback.id,
              reply: this.replyForm.reply,
              reply_id: this.userInfo.id
            };
            const res = await adminAddRating(params);
            if (res.code === 200) {
              this.$message.success("回复成功");
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message.error(res.msg || "回复失败");
            }
          } else {
            // 用户评价：原接口
            const params = {
              id: this.currentFeedback.id,
              reply: this.replyForm.reply,
              reply_id: this.userInfo.id,
            };
            const res = await updateRatingShow(params);
            if (res.code === 200) {
              this.$message.success("回复成功");
              this.dialogVisible = false;
              this.getList();
            } else {
              this.$message.error(res.msg || "回复失败");
            }
          }
        } catch (err) {
          console.log(err)
          this.$message.error("回复失败，请重试");
          console.error(err);
        } finally {
          this.loading = false;
        }
      });
    },

    handleSelectionChange(val) {
      this.idList = val.map(i => i.id);
    },

    openScoreSettingDialog() {
      getSystenList().then(res => {
        this.scoreForm.scoring = res.scoring;
        this.scoreForm.points = res.points;
      });
      this.scoreSettingDialogVisible = true;
    },

    handleDialogClose() {
      this.scoreSettingDialogVisible = false;
    },

    saveScoreSetting() {
      this.$refs.scoreForm.validate(valid => {
        if (valid) {
          this.loading = true;
          const params = {
            id: 1,
            scoring: this.scoreForm.scoring,
            points: this.scoreForm.points,
            operator: this.userInfo.id
          };

          updateSystem(params)
            .then(res => {
              if (res.code === 200) {
                this.$message.success('保存成功');
                this.scoreSettingDialogVisible = false;
              } else {
                this.$message.error(res.msg || '保存失败');
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },

    formatAnswer(content, question) {
      if (!content || !question) return '';
      const item = content.find(item => item.question === question);
      return item ? item.answer : "";
    }
  }
};
</script>

<style lang="scss" scoped>
.mainColor {
  color: #2dc0a3;
}

.content {
  height: calc(100% - 56px);
  overflow-y: auto;
}

.bgW {
  background: #fff;
  border-radius: 3px;
  padding: 10px;
  margin-bottom: 20px;
}

.accountCon {
  background: #fff;
  padding: 0px 10px 80px;

  .btnBox {
    display: flex;
    gap: 10px;
  }
}

.score-stars {
  color: #e4e4e4;
  margin-top: 4px;

  .star-active {
    color: #f5a623;
  }
}

.reply-dialog {
  .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
    padding: 20px;
  }
}

.info-card {
  background: #f9f9f9;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid #eee;

  &.customer-info {
    border-left: 3px solid #2dc0a3;
  }

  &.reply-section {
    border-left: 3px solid #33bea7;
  }

  .card-title {
    margin-top: 0;
    margin-bottom: 15px;
    color: #333;
    font-size: 16px;
    font-weight: 500;
    border-bottom: 1px dashed #eee;
  }
}

.feedback-detail {
  .feedback-item {
    margin-bottom: 12px;
    line-height: 1.8;

    .label {
      font-weight: 500;
      color: #666;
    }

    &.evaluation-content-wrapper {
      margin-bottom: 0;

      .evaluation-content {
        background: #fff;
        padding: 10px;
        border-radius: 4px
      }
    }
  }
}

.reply-list {
  .reply-item {
    padding: 8px 12px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 8px;
    
    span {
      font-size: 12px;
      color: #999;
    }
    p {
      margin: 4px 0 0;
      line-height: 1.5;
    }
  }
}

.reply-textarea {
  width: 100%;
}

.w-full {
  width: 100%;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.theme {
  color: #2dc0a3;
  cursor: pointer;
  margin-right: 15px;

  &:hover {
    text-decoration: underline;
  }
}

.add-evaluate-wrap {
  padding: 10px 0;

  .form-section {
    margin-bottom: 25px;

    .section-title {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
      color: #333;
      margin-bottom: 15px;
      padding-left: 10px;
      border-left: 3px solid #33bea7;
    }
  }

  .questions-group {
    .question-item {
      background: #f9f9f9;
      border-radius: 6px;
      padding: 12px 15px;
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>